import Router from "@/Router";
import { BrowserRouter } from "react-router-dom";
import Toaster from "@/Components/Toast";

const App = () => {
  return (
    <BrowserRouter>
      <Router />
      <Toaster />
    </BrowserRouter>
  );
};

export default App;

